import { observable, computed, action } from "mobx";
import { AsyncOperationsModel } from "../../../../utility/AsyncOperationsModel";
import { IResult } from "../../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { observer } from "mobx-react";
import BaseComponent from "../../../../utility/BaseComponent";
import { SelectField, Snackbar, Button, Card, TextField } from "react-md";
import * as React from "react";
import StyledTable from "../../../../component/StyledTable/StyledTable";
import _ = require("lodash");
import { IUsersOperations } from "../../../../utility/admin/UsersControls/UsersOperations/IUsersOperations";
import VerifyDeleteResultDialog,
{ VerifyDeleteResultDialogModel } from "./VerifyDeleteResultsDialog/VerifyDeleteResultsDialog";
import ViewResultDialog, { ViewResultDialogModel } from "./ViewResultDialog/ViewResultDialog";
import "./static/ResultsTableView.scss";
import * as moment from 'moment';

export class ResultsTableViewModel extends AsyncOperationsModel {

    @computed get tableHeaders() {
        let output = [];
        if (!this.isPublic) {
            output.push("Username");
        }
        output = output.concat(["Course", "Module", "Name"]);
        if (!this.isSportIreland) {
            output.push("Role");
        }
        if (this.isSportIreland) {
            output.push("County");
        }
        if (this.isHSCT ) {
            output.push("Trust");
        }

        output = output.concat(["Date", "Score"]);
        if (this.isSportIreland) {
            output.push("NGB");
            output.push("Sport");
            output.push("Club");
        }

        return output;

    }

    @computed get tableData() {
        return this.visibleResults.map(
            result => {
                let resultDate = moment(result.submit_time).toDate();
                let output = [];
                if (!this.isPublic) {
                    output.push(result.username);
                }
                output = output.concat([result.course_name, result.module_name, result.submitted_name]);
                if (!this.isSportIreland) {
                    output.push(result.role_name);
                }
                if (this.isSportIreland) {
                    output.push(result.groupName);
                }
                if (this.isHSCT) {
                    output.push(result.groupName);
                }
                output = output.concat([moment(resultDate).format("YYYY-MM-DD ddd"), result.score.toString()]);

                if (this.isSportIreland && !isNullOrUndefined(result.additionalData)) {
                    if (!isNullOrUndefined(result.additionalData.customOrganisation)) {
                        output.push(result.additionalData.customOrganisation);
                    } else {
                        output.push("N/A");
                    }

                    if (!isNullOrUndefined(result.additionalData.sport)) {
                        output.push(result.additionalData.sport);
                    } else {
                        output.push("N/A");
                    }
                    if (!isNullOrUndefined(result.additionalData.club)) {
                        output.push(result.additionalData.club);
                    } else {
                        output.push("N/A");
                    }
                }

                return output;
            }
        );
    }

    @computed get moduleDropdownList() {
        return this.originalResults.map(
            result => {
                return {label: result.module, value: result.module};
            }
        );
    }

    @computed get courseDropdownList() {
        return this.originalResults.map(
            result => {
                return {label: result.course, value: result.course};
            }
        );
    }

    @computed get showExtraActions() {
        return this.selectedResults.length > 0;
    }

    @observable searchQuery = "";
    @observable visibleResults: IResult[];
    @observable selectedCourseCode: string;
    @observable selectedModuleCode: string;
    @observable selectedResults: IResult[] = [];
    @observable deleteDialogModel: VerifyDeleteResultDialogModel;
    @observable selectedRoleId: string = "";
    @observable viewDialogModel: ViewResultDialogModel;
    @observable toasts: string[] = [];
    @observable isPublic: boolean = false;
    @observable organisationCode: string = "";
    @observable isSportIreland: boolean = false;
    @observable isHSCT: boolean = false;

    @computed get roles() {
        if (!isNullOrUndefined(this.originalResults) && !this.isPublic) {
            let output: { label: string, value: string }[] = [];
            output.push({label: "All Roles", value: ""});
            this.originalResults.forEach(
                result => {
                    if (output.map(item => item.label).indexOf(result.role_name) === -1) {
                        output.push({label: result.role_name, value: result.role_id});
                    }
                }
            );
            return output;
        } else {
            return [];
        }
    }

    public userOperations: IUsersOperations;
    readonly originalResults: IResult[];

    constructor(results: IResult[], userOperations: IUsersOperations, organisationCode: string, isPublic?: boolean) {
        super();
        this.originalResults = results;
        this.visibleResults = this.originalResults;
        this.userOperations = userOperations;
        this.organisationCode = organisationCode;
        this.deleteDialogModel = new VerifyDeleteResultDialogModel(this.userOperations, this.onDeleteComplete);
        this.viewDialogModel = new ViewResultDialogModel(this.onCloseViewDialog);
        if (!isNullOrUndefined(isPublic)) {
            this.isPublic = isPublic;
        }
        this.isSportIreland = organisationCode.toUpperCase() === "ISCSS";
        this.isHSCT = organisationCode.toUpperCase() === "HSCT";

    }

    @action.bound
    setToast(message: string) {
        this.toasts.push(message);
    }

    @action.bound
    dismissToast() {
        this.toasts.splice(0, this.toasts.length);
    }

    @action.bound
    onCloseViewDialog() {
        this.viewDialogModel.setResult(undefined);
        this.viewDialogModel.setShowDialog(false);
    }

    @action.bound
    onSearchQueryChanged(value: string) {
        this.searchQuery = value;
        this.visibleResults = this.originalResults.filter(
            item => {
                return (
                        (!this.isPublic &&
                            (item.username.indexOf(value) > -1 || item.submitted_name.indexOf(value) > -1)) ||
                        (this.isPublic && item.submitted_name.indexOf(value) > -1) ||
                        (this.isPublic && this.isSportIreland &&
                            ((!isNullOrUndefined(item.additionalData.sport) &&
                                item.additionalData.sport.indexOf(value) > -1)
                                ||
                                (!isNullOrUndefined(item.additionalData.club) &&
                                    item.additionalData.club.indexOf(value) > -1)
                                ||
                                (!isNullOrUndefined(item.additionalData.customOrganisation) &&
                                    item.additionalData.customOrganisation.indexOf(value) > -1)))
                    ) &&
                    (
                        isNullOrUndefined(this.selectedCourseCode) ||
                        (!isNullOrUndefined(this.selectedCourseCode) && item.course === this.selectedCourseCode)
                    ) &&
                    (
                        isNullOrUndefined(this.selectedModuleCode) ||
                        (!isNullOrUndefined(this.selectedModuleCode) && item.module === this.selectedModuleCode)
                    );
            }
        );
    }

    @action.bound
    onCourseItemSelected(value: string) {
        this.selectedCourseCode = value;
        this.onSearchQueryChanged(this.searchQuery);
    }

    @action.bound
    onModuleItemSelected(value: string) {
        this.selectedCourseCode = value;
        this.onSearchQueryChanged(this.searchQuery);
    }

    @action.bound
    onRowSelected(rows: Array<Array<string>>) {
        rows.forEach((row, index) => {

            let selectedResult = this.isPublic ? this.transfromRowToPublicResult(row) : this.transfromRowToResult(row);
            if (!isNullOrUndefined(selectedResult)) {
                let alreadySelectedIndex = this.selectedResults.findIndex(item =>
                                                                              _.isEqual(selectedResult, item));
                if (alreadySelectedIndex > -1) {
                    this.selectedResults.splice(alreadySelectedIndex, 1);
                } else {
                    this.selectedResults.push(selectedResult);
                }
            }

        });

    }

    @action.bound
    onRoleSelected(value: string) {
        if (value === "") {
            this.visibleResults = this.originalResults;
        } else {
            this.selectedRoleId = value;
            this.clearSelectedResults();
            this.visibleResults = this.originalResults.filter(item => item.role_id === value);
        }

    }

    @action.bound
    clearSelectedResults() {
        this.selectedResults = [];
    }

    @action.bound
    resetAsyncOperations() {
        this.asyncOperationsCount = 0;
    }

    @action.bound
    onViewClicked(row: string[]) {
        let result = this.isPublic ? this.transfromRowToPublicResult(row) : this.transfromRowToResult(row);
        if (!isNullOrUndefined(result)) {
            this.viewDialogModel.setResult(result);
            this.viewDialogModel.setShowDialog(true);
        }
    }

    @action.bound
    onDeleteClicked(row: string[]) {
        let result = this.isPublic ? this.transfromRowToPublicResult(row) : this.transfromRowToResult(row);
        if (!isNullOrUndefined(result)) {
            this.deleteDialogModel.setSelectedResults([result]);
            this.deleteDialogModel.setDialogVisibility(true);
        }
    }

    @action.bound
    onDeleteSelectedClicked() {
        this.deleteDialogModel.setSelectedResults(this.selectedResults);
        this.deleteDialogModel.setDialogVisibility(true);
    }

    @action.bound
    onDeleteComplete(deletedResults?: IResult[]) {
        this.deleteDialogModel.setDialogVisibility(false);
        if (!isNullOrUndefined(deletedResults)) {
            deletedResults.forEach((deletedResult) => {
                let resultIndex = this.originalResults
                    .findIndex(originalResult => _.isEqual(originalResult, deletedResult));
                if (resultIndex > -1) {
                    this.originalResults.splice(resultIndex, 1);
                }
                this.visibleResults = this.originalResults;
            });
            this.setToast(`Deleted Result${this.selectedResults.length > 1 ? "s" : ""} Successfully`);
        }
    }

    private transfromRowToResult(row: string[]): IResult {
        let resultIndex = this.visibleResults.findIndex(
            item =>
                item.username === row[0] &&
                item.course_name === row[1] &&
                item.module_name === row[2] &&
                (item.score.toString() === row[6] || item.score.toString() === row[7])
        );
        if (resultIndex > -1) {
            return this.visibleResults[resultIndex];
        } else {
            return undefined;
        }
    }

    private transfromRowToPublicResult(row: string[]): IResult {
        let resultIndex = this.visibleResults.findIndex(
            item =>
                item.submitted_name === row[2] &&
                item.course_name === row[0] &&
                item.module_name === row[1] &&
                item.score.toString() === row[5]
        );
        if (resultIndex > -1) {
            return this.visibleResults[resultIndex];
        } else {
            return undefined;
        }
    }
}

@observer
class ResultsTableView extends BaseComponent<{ model: ResultsTableViewModel }, {}> {
    render() {
        return (
            <div className="ResultsTableContainer">
                <Card>
                    <div className="ResultsTableHeader">
                        <TextField
                            id="usernameSearch"
                            label={this.props.model.isPublic ?
                                (`Search By Name${this.props.model.isSportIreland ? "/NGB/Sport/Club" : ""}`)
                                : "Search By Username/Name"}
                            lineDirection="center"
                            placeholder="Type in your search term (case sensitive)"
                            className="md-cell md-cell--bottom"
                            value={this.props.model.searchQuery}
                            onChange={(e) => this.props.model.onSearchQueryChanged(e.toString())}
                        />
                        {
                            !this.props.model.isPublic &&
                            <div className="ResultsTableHeaderFilters">
                                <h5>Filter By: </h5>
                                <SelectField
                                    style={{width: "80px"}}
                                    id="roles-filter"
                                    label="Role"
                                    placeholder="Select A Role"
                                    menuItems={this.props.model.roles}
                                    value={this.props.model.selectedRoleId}
                                    onChange={(value) => this.props.model
                                        .onRoleSelected(value.toString())}
                                />
                            </div>

                        }
                        {
                            this.props.model.showExtraActions &&
                            <div className="ResultsTableHeaderSelectedActions">
                                <Button
                                    flat={true}
                                    secondary={true}
                                    onClick={this.props.model.onDeleteSelectedClicked}
                                >
                                    Delete
                                </Button>
                            </div>
                        }
                        <Button
                            id="csv-export"
                            secondary={true}
                            flat={true}
                            onClick={() => {
                                this.props.model.userOperations
                                    .getApi()
                                    .exportTableDataAsCSV(this.props.model.tableHeaders, this.props.model.tableData)
                                    .subscribe(
                                        downloadedFile => {

                                            let element = document.createElement("a");
                                            element.href = URL.createObjectURL(downloadedFile);
                                            element.download =
                                                `results-${moment().toDate().toLocaleDateString()}.csv`;
                                            element.click();
                                        }
                                    );

                            }}
                        >
                            Export Results
                        </Button>
                    </div>
                    <StyledTable
                        selectable={true}
                        withActions={true}
                        onItemSelected={this.props.model.onRowSelected}
                        headers={this.props.model.tableHeaders}
                        data={this.props.model.tableData}
                        clearSelected={this.props.model.clearSelectedResults}
                        actions={
                            [
                                {
                                    label: "View",
                                    onClick: (row) => {
                                        this.props.model.onViewClicked(row);
                                    }
                                },
                                {
                                    label: "Delete",
                                    onClick: (row) => {
                                        this.props.model.onDeleteClicked(row);
                                    }
                                }
                            ]
                        }
                    />
                    <VerifyDeleteResultDialog model={this.props.model.deleteDialogModel}/>
                    <ViewResultDialog model={this.props.model.viewDialogModel}/>
                    <Snackbar
                        id="example-snackbar"
                        toasts={this.props.model.toasts.map(item => {
                            return {
                                text: item
                            };
                        })}
                        autohide={true}
                        onDismiss={this.props.model.dismissToast}
                    />
                </Card>
            </div>
        );
    }
}

export default ResultsTableView;


// WEBPACK FOOTER //
// ./src/view/Admin/ResultsView/ResultsTableView/ResultsTableView.tsx